import { Browser, Device, Platform } from "@identity/utils";
import { SentryLoader } from "../../sentry-loader";
import { inject, injectable } from "tsyringe";
import { SENTRY } from "@identity/symbols";

@injectable()
export class SentryContextService {
  constructor(
    @inject(SENTRY) private readonly sentry: SentryLoader,
    @inject(Browser) private readonly browser: Browser,
    @inject(Device) private readonly device: Device,
    @inject(Platform) private readonly platform: Platform,
  ) {
    this.sentry.setTags({
      browser: this.browser.getBrowser(),
      device: this.device.getDeviceType(),
      platform: this.platform.get(),
    });
  }
}
